import z from "zod";

const environmentSchema = z.object({
	VITE_API_URL: z
		.url()
		.nullish()
		.transform((value) => value ?? "https://timeghost-dev.azurewebsites.net/api"),
});

const environment = environmentSchema.parse(process.env);

export default environment;
